import { Injectable, Injector } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';


@Injectable({
  providedIn: 'root'
})
export class WorkingDaysService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {

  }

  Save(id: number) {
    return this.http.post(this.configurations.apiAddress + "/api/WorkingDay/save/", id);
  }

  Search(searchText: string, pageSize: number, pageNumber: number) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
      .set("pageNumber", pageNumber.toString())
      .set("pageSize", pageSize.toString());
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/search', { params: myParams });
  }

  GetAll() {
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/getAll');
  }

  Delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/WorkingDay/delete/' + id);
  }

  GetById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/getById/' + id);
  }

  AmCheck(id: number) {   
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/AmCheck/' + id);
  }

  PmCheck(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/PmCheck/' + id);
  }

  Reorder(orderedIds: number[]) {
    return this.http.post(this.configurations.apiAddress + '/api/WorkingDay/reorder', orderedIds);
  }

  // the 7 days in force today for the company (no ids), a business unit, or a user
  GetScope(businessUnitId?: number, userId?: number) {
    let myParams = new HttpParams();
    if (businessUnitId) myParams = myParams.set('businessUnitId', businessUnitId.toString());
    if (userId) myParams = myParams.set('userId', userId.toString());
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/scope', { params: myParams });
  }

  // changes one day of a scope from today on (earlier dates keep their setting)
  SetDay(change: { businessUnitId?: number, userId?: number, workingDayId: number, amActive: boolean, pmActive: boolean }) {
    return this.http.post(this.configurations.apiAddress + '/api/WorkingDay/scope/day', change);
  }

  // rearranges a scope's week (day ids first to last) from today on
  ReorderScope(businessUnitId: number, userId: number, orderedIds: number[]) {
    return this.http.post(this.configurations.apiAddress + '/api/WorkingDay/scope/reorder', { businessUnitId, userId, orderedIds });
  }

  // ends a business unit's or user's own days from today, so it inherits again
  ResetScope(businessUnitId?: number, userId?: number) {
    let myParams = new HttpParams();
    if (businessUnitId) myParams = myParams.set('businessUnitId', businessUnitId.toString());
    if (userId) myParams = myParams.set('userId', userId.toString());
    return this.http.post(this.configurations.apiAddress + '/api/WorkingDay/scope/reset', null, { params: myParams });
  }

  // the week(s) in force during a month (as they were then) for a user, a business unit or the company, with the month's working days
  GetMonthHistory(year: number, month: number, businessUnitId?: number, userId?: number) {
    let myParams = new HttpParams().set('year', year.toString()).set('month', month.toString());
    if (businessUnitId) myParams = myParams.set('businessUnitId', businessUnitId.toString());
    if (userId) myParams = myParams.set('userId', userId.toString());
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/history', { params: myParams });
  }

  GetUncoveredBusinessUnits() {
    return this.http.get(this.configurations.apiAddress + '/api/WorkingDay/uncoveredBusinessUnits');
  }

}
